import styled from 'styled-components'

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`

export const TableHeadCell = styled.th`
  padding: 0.15rem 0.4rem 0.2rem 0;
  text-align: left;
  font-weight: 500;
  color: var(--muted-foreground);
  border-bottom: 0.0625rem solid var(--border);
`
